import { render, staticRenderFns } from "./StepPublish.vue?vue&type=template&id=3bfc2330&scoped=true"
import script from "./StepPublish.vue?vue&type=script&lang=js"
export * from "./StepPublish.vue?vue&type=script&lang=js"
import style0 from "./StepPublish.vue?vue&type=style&index=0&id=3bfc2330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc2330",
  null
  
)

export default component.exports